import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Nav } from 'components/graylog';
import { LinkContainer } from 'react-router-bootstrap';

import CombinedProvider from 'injection/CombinedProvider';
import connect from 'stores/connect';
import Routes from 'routing/Routes';
import InactiveNavItem from './InactiveNavItem';

const { NotificationsActions, NotificationsStore } = CombinedProvider.get('Notifications');

class NotificationBadge extends React.PureComponent {
  static propTypes = {
    total: PropTypes.number,
  };

  static defaultProps = {
    total: undefined,
  };

  POLL_INTERVAL = 3000;

  componentDidMount() {
    NotificationsActions.list();
    this.interval = setInterval(NotificationsActions.list, this.POLL_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { total } = this.props;
    if (!total) {
      return null;
    }
    return (
      <Nav navbar>
        <LinkContainer to={Routes.SYSTEM.OVERVIEW}>
          <InactiveNavItem className="notification-badge-link">
            <Badge bsStyle="danger" id="notification-badge">{total}</Badge>
          </InactiveNavItem>
        </LinkContainer>
      </Nav>
    );
  }
}

export default connect(NotificationBadge, { notifications: NotificationsStore }, ({ notifications }) => ({ total: notifications ? notifications.total : undefined }));
